// extracted by mini-css-extract-plugin
module.exports = {"notFound":"styles_notFound__364XC"};